/**
 * @author xyguo
 * @description 角色管理==》人员维护==》添加人员==》查找人员,可在该角色下添加人员
 * @Date 2020/1/2
 */
import React from "react";
import { connect } from "dva";
import { modelUtils, Storage, jsonToString } from "@/utils";
import { Spin } from "antd";
import { utils_tool, component_tool, framework_tool } from "@/tool";
import './index.less'
const {
  WizCard,
  WizSearchBar,
  WizDataTable,
  WizButton,
  WizModalForm,
  WizAlert,
  WizModalTable,
  WizListSelect,
  WizRow,
  WizCol
} = component_tool;
const { WizContainer } = framework_tool;
const { getPageData } = utils_tool;

import createColumns from "./listSelectColumns";

class ListSelect extends WizContainer {
  componentName = "ListSelect";

  constructor(props) {
    super(props);
    this.buildActionKey();
    this.state = {
      defaultSearch: true,
      apiParams: {},
      visible: false,
      record: null
    };
  }

  static defaultProps = {
    selectedRows: []
  }

  propsAndStateOnChange = {
    updateGroup: this._GroupOnChange.bind(this),
    addGroup: this._GroupOnChange.bind(this)
  };

  _GroupOnChange(nextProps, nextState) {
    this._getData();
    return true;
  }

  _componentDidMount = () => {
    if (this.state.defaultSearch) {
      this._getData();
    }
  };

  _getData(other = {}) {
    this.doAction({
      path: "groupManagement/groupListFilter",
      payload: {
        key: "groupListKey",
        apiParams: { ...this.state.apiParams, ...other ,roleId:this.props.roleId,state:"ENABLE"}
      }
    });
  }

  _onManagement(record){
    alert("待完善。。。");
  }

  _render() {
    const { groupList, GroupManagementLoading, selectedRows, updateRows, handleClear } = this.props;
    const { record, visible } = this.state;
    const dataItems = getPageData(groupList.data);
    const other = {};
    const columns = createColumns(this, dataItems, other);
    const searchBarProps = {
      columns,
      collapse: false,
      onSearch: values =>
        this.setState({ apiParams: values }, () => {
          this._getData();
        })
    };

    const dataTableProps = {
      loading: GroupManagementLoading,
      columns,
      rowKey: "id",
      dataItems,
      selectType: "checkbox",
      showNum: false,
      isScroll: true,

      onChange: ({ pageNum, pageSize }) => {
        this._getData({ current: pageNum, size: pageSize });
      },
      selectedRowKeys: selectedRows.map(item => item.rowKey),
      onSelect: (keys, rows) => {
        rows.forEach(data =>{//为适应用户组件,将用户组中 name变更为useName code变更为fullName
          // data.userName = data.name
          data.fullName =  data.code
        });
        this.keys = keys;
        updateRows(rows)
      }
    };

    const listSelectProps = {
      className: 'role-group-modalList',
      type: '用户组',
      rows: selectedRows,
      handerClear: (id) => {
        handleClear(id)
      }
    }

    return (
      <WizRow>
        <WizCol span={16}>
          <WizCard bodyStyle={{ padding: '0 15px' }}>
            <WizSearchBar
              type="grid"
              {...searchBarProps}
              cols={{ xs: 14, md: 12, xl: 10 }}
            />
            <WizDataTable style={{ marginTop: 15 }} {...dataTableProps} />
            <div className="pagination">
              <WizDataTable.Pagination {...dataTableProps} />
            </div>
          </WizCard>
        </WizCol>
        <WizCol span={8} >
          <WizListSelect { ...listSelectProps } />
        </WizCol>
      </WizRow>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { groupManagement } = state;
  const groupList = modelUtils.getModelEntity(groupManagement, "groupListKey");
  const addGroup = modelUtils.getModelEntity(groupManagement, "addGroup");
  const updateGroup = modelUtils.getModelEntity(groupManagement, "updateGroup");
  const load = modelUtils.getLoadingState(state, "groupManagement");
  return {
    groupList: groupList,
    addGroup,
    updateGroup,
    ...load
  };
};


export default connect(mapStateToProps)(ListSelect);
